import { Profile } from '../../authentication/builders/profile_builder';

export class ProfileServant {
  cleanForForm(profile: Partial<Profile>): Profile {
    let cleanProfile = _.clone(profile);
    cleanProfile.gpa = cleanProfile.gpa ? Number(cleanProfile.gpa) : '';
    cleanProfile.date_of_birth = cleanProfile.date_of_birth
      ? moment(cleanProfile.date_of_birth as string).toDate()
      : null;
    return cleanProfile;
  }

  cleanForServer(profile: Profile): Profile {
    let cleanProfile = _.clone(profile);
    cleanProfile.gpa = cleanProfile.gpa ? Number(cleanProfile.gpa) : null;
    cleanProfile.date_of_birth = cleanProfile.date_of_birth
      ? moment(cleanProfile.date_of_birth).format('YYYY-MM-DD')
      : null;
    return cleanProfile;
  }
}

angular.module('capability-ng-user-app').service('ngProfileServant', ProfileServant);



// WEBPACK FOOTER //
// ./app/lib/user_app/servants/profile_servant.ts